import ErrorType from '../Constants/Error.type';

class ErrorPayload {
    constructor(type, source) {
        this.type = type || ErrorType.UNKNOWN_ERROR,
        this.source = source || new TypeError('Error source not defined');
    }
}

export default ErrorPayload;
